module.exports = EventEmitter3;